export default "__VITE_ASSET__D8$BEQYb__"